import { PlusOutlined } from "@ant-design/icons"
import {Row, Col, Space, Button, Typography} from "antd"
export const ModuleTopHeading=({name, onClick})=>{
    return (
        <Row>
            <Col span={24}>
                <Space className="align-center">
                    <Typography.Title level={4} className="my-0">
                        {
                            name
                        }
                    </Typography.Title>
                    {
                        onClick ?
                        <Button 
                            type="primary" 
                            shape="circle" 
                            size='small' 
                            className="center"
                            icon={<PlusOutlined/>}
                            onClick={onClick}
                        />
                        :<></>
                    }
                </Space>
            </Col>
        </Row>
    )
}